// Phase 999.4 Plan 07 — Step E: review summary + Confirm button.
//
// SPEC R6 / R8 / R9: Step E is the only place in the wizard that reaches the
// server's transactional surface. Confirm dispatches SUBMIT then issues the
// SINGLE POST /api/admin/sites — handled by the parent CreateSiteWizard
// component because the parent owns the inline SuccessPanel rendering branch
// (D-11). This step receives onConfirm + onPrev as props so the wizard shell
// can sequence the dispatches itself.
//
// All values rendered through JSX are React-escaped (T-999.4-45 mitigation).
// The UTM JSON is wrapped in a <code> block which is also escaped — even if an
// operator pastes a stray `<script>` tag into the field, React stringifies it.

import React from 'react';
import { Form, Table, Button, Alert } from 'reactstrap';

export function StepE_Confirm({ state, onConfirm, onPrev }) {
    const overrideEntries = Object.entries(state.optionOverrides);
    return (
        <Form>
            <h4>Step E — Confirm</h4>
            <p>
                Review the new site below. Clicking Confirm performs a single transactional commit;
                nothing has been written to the database yet.
            </p>
            <h6>Organisation</h6>
            <Table size="sm" bordered>
                <tbody>
                    <tr>
                        <th style={{ width: '20%' }}>Mode</th>
                        <td>{state.org.id ? 'Use existing' : 'Create new'}</td>
                    </tr>
                    <tr>
                        <th>Name</th>
                        <td>{state.org.name}</td>
                    </tr>
                    {!state.org.id && (
                        <tr>
                            <th>Description</th>
                            <td>{state.org.description}</td>
                        </tr>
                    )}
                </tbody>
            </Table>

            <h6>Site (OrgLocation)</h6>
            <Table size="sm" bordered>
                <tbody>
                    <tr><th style={{ width: '20%' }}>Name</th><td>{state.orglocation.name}</td></tr>
                    <tr><th>Description</th><td>{state.orglocation.description}</td></tr>
                    <tr><th>UTM JSON</th><td><code>{state.orglocation.utmJson}</code></td></tr>
                </tbody>
            </Table>

            <h6>Hardware ({state.hardware.length} rows)</h6>
            <Table size="sm" bordered>
                <thead>
                    <tr><th>#</th><th>Name</th><th>Description</th></tr>
                </thead>
                <tbody>
                    {state.hardware.map((h, i) => (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{h.name}</td>
                            <td>{h.description}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <h6>Option overrides ({overrideEntries.length} rows)</h6>
            {overrideEntries.length === 0 ? (
                <p className="text-muted small">No overrides — defaults apply.</p>
            ) : (
                <Table size="sm" bordered>
                    <thead><tr><th>OptionTypeId</th><th>Value</th></tr></thead>
                    <tbody>
                        {overrideEntries.map(([k, v]) => (
                            <tr key={k}><td>{k}</td><td><code>{v}</code></td></tr>
                        ))}
                    </tbody>
                </Table>
            )}

            {state.errors && state.errors.submit && (
                <Alert color="danger" data-testid="step-e-error">Submit failed: {state.errors.submit}</Alert>
            )}

            <div className="mt-3">
                <Button color="secondary" onClick={onPrev} disabled={state.submitting} data-testid="step-e-back-btn">
                    ← Back
                </Button>
                {' '}
                <Button
                    color="primary"
                    onClick={onConfirm}
                    disabled={state.submitting}
                    data-testid="step-e-confirm-btn"
                >
                    {state.submitting ? 'Creating...' : 'Confirm'}
                </Button>
            </div>
        </Form>
    );
}

export default StepE_Confirm;
